// extracted by mini-css-extract-plugin
export default {"overlay":"XAlbJ","overlayCentered":"BzCxa","modal":"Tf5en","icon":"Ap9UA"};